import { DocumentStatus } from "../../../base/documents/document-statuses/document-status.model";

export class PurchaseDocumentStatus extends DocumentStatus { }
